/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { withTheme } from '@emotion/react';
import { useSelector } from 'react-redux';
import { selectAuditLogs } from 'modules/audit-logs/selectors';
import { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { TABLE_HEADER_FONT_COLOR } from 'modules/common/constants/style';
import { Grid } from '@mui/material';
import { isEmpty } from 'modules/common/helpers/object';
import './index.scss';
/**
 * Data grid to display all user invitations
 * @returns
 */
const AuditLogsTable = () => {
  //
  const auditLogs = useSelector(selectAuditLogs);
  const [filteredAuditLogs, setFilteredAuditLogs] = useState([]);
  //
  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      headerClassName: 'super-app-theme--header',
      hide: true,
      flex: 1,
    },
    {
      field: 'requestId',
      headerName: 'Request ID',
      headerClassName: 'super-app-theme--header',
      flex: 1,
    },
    {
      field: 'username',
      headerName: 'Username',
      headerClassName: 'super-app-theme--header',
      flex: 1,
    },
    {
      field: 'eventName',
      headerName: 'Event Name',
      headerClassName: 'super-app-theme--header',
      flex: 1,
    },
    {
      field: 'component',
      headerName: 'Component',
      headerClassName: 'super-app-theme--header',
      flex: 1,
    },
    {
      field: 'eventStartTime',
      headerName: 'Event Start Time',
      headerClassName: 'super-app-theme--header',
      flex: 1,
    },
    {
      field: 'eventEndTime',
      headerName: 'Event End Time',
      headerClassName: 'super-app-theme--header',
      flex: 1,
    },
  ];
  //
  useEffect(() => {
    if (!isEmpty(auditLogs)) {
      const formattedAuditLogs = [];
      auditLogs?.forEach((auditLog) => {
        auditLog?.events.forEach((auditEvent) => {
          formattedAuditLogs.push({
            id: Math.random().toString(16).slice(2),
            requestId: auditLog.requestId,
            username: auditLog.username || 'N/A',
            eventName: auditEvent.eventName,
            component: auditEvent.component || 'N/A',
            eventStartTime: auditLog.createdAt,
            eventEndTime: auditLog.updatedAt,
          });
        });
      });
      setFilteredAuditLogs(formattedAuditLogs);
    } else {
      setFilteredAuditLogs([]);
    }
  }, [auditLogs]);
  //
  return (
    <Grid container sx={{ height: 600 }}>
      <DataGrid
        sx={{
          overflowWrap: 'break-word',
          '& .super-app-theme--header': {
            backgroundColor: 'white',
            color: TABLE_HEADER_FONT_COLOR,
          },
          '& .MuiDataGrid-main': {
            backgroundColor: 'white',
          },
          '.MuiDataGrid-footerContainer': {
            backgroundColor: 'white',
          },
        }}
        rowHeight={50}
        rows={filteredAuditLogs || []}
        columns={columns}
      />
    </Grid>
  );
};
//
export default withTheme(AuditLogsTable);
